// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","title":"home_title__qJOOZ"};